import { render } from "./MainTitle.vue?vue&type=template&id=2d41dfce&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"

import "./MainTitle.vue?vue&type=style&index=0&id=2d41dfce&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d41dfce"]])

export default __exports__